import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Form, Space, Tooltip } from 'antd'
import dayjs from 'dayjs'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import { formatCurrencyLabel, hasPermission } from '../../config-func'
import { OPTIONS_RECRUITMENT, PAGE_SIZE_OPTIONS } from '../../configData'
import {
  AuctionViewHistoryDelete,
  AuctionViewHistoryUpdate,
  getHouseViewAuction
} from '../../services/house-viewing-auction'
import Card from '../Card'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import AuthenticatedLink from '../Export/AuthenticatedLink'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import ModalCustom from '../common/Modal/ModalCustom'
import Loading from '../Loading';

const AuctionViewHistory = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [dataSource, setDataSource] = useState([])
  const [detail, setDetail] = useState({})
  const [form] = Form.useForm()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState('')
  const [listDepartment, setListDepartment] = useState([])
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    // let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      post_id: filters.post_id || '',
      status: filters.status || '',
      type: filters.type || '',
      project_id: filters.project_id || '',
      start_date:
        (filters?.date && dayjs(filters?.date[0], 'DD/MM/YYYY').valueOf()) ||
        '',
      end_date:
        (filters?.date && dayjs(filters?.date[1], 'DD/MM/YYYY').valueOf()) || ''
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await getHouseViewAuction(cleanedData)
      // if (response?.code === 0) {
      // _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification('error', error?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
      // setTotal(_total)
      setDataSource(_dataSource)
    }
  }
  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },

    {
      title: 'Mã tin',
      dataIndex: 'post_info',
      key: 'post_info',
      width: 100,
      render: (_, record) => {
        return <div>{record?.post_info?.id}</div>
      }
    },
    {
      title: 'Tiêu đề',
      dataIndex: 'post_info',
      key: 'post_info',
      width: 200,
      render: (_, record) => {
        return <div>{record?.post_info?.title}</div>
      }
    },
    {
      title: 'Dự án',
      dataIndex: 'post_info',
      key: 'post_info',
      width: 200,
      render: (_, record) => {
        return <div>{record?.post_info?.project_info?.project_name}</div>
      }
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      width: 200,
      render: (_, record) => {
        const status = OPTIONS_RECRUITMENT.find(opt => opt.value === record?.status);
        return <div>{status?.name || ''}</div>;
      }
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'type',
      key: 'type',
      width: 100,
      render: (_, record) => {
        return (
          <div>
            {record?.type == 1 ? 'Đấu giá' : record?.type == 2 ? 'Xem nhà' : ''}
          </div>
        )
      }
    },
    {
      title: 'Họ tên',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 150,
      render: (_, record) => {
        return <div>{record?.post_info?.user_info?.name}</div>
      }
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 120,
      render: (_, record) => {
        return <div>{record?.post_info?.user_info?.phone}</div>
      }
    },
    {
      title: 'Mã căn hộ',
      dataIndex: 'post_info',
      key: 'post_info',
      width: 120,
      render: (_, record) => {
        return <div>{record?.post_info?.apartment_code}</div>
      }
    },
    {
      title: 'Giá bán',
      dataIndex: 'post_info',
      key: 'post_info',
      width: 150,
      render: (_, record) => {
        return <div>{formatCurrencyLabel(record?.post_info?.price)}</div>
      }
    },
    {
      title: 'Giá đấu giá',
      dataIndex: 'price',
      key: 'price',
      width: 150,
      render: (_, record) => <span>{formatCurrencyLabel(record.price)}</span>
    },
    {
      title: 'Người yêu cầu',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: 130
    },
    {
      title: 'Email yêu cầu',
      dataIndex: 'customer_email',
      key: 'customer_email',
      width: 130
    },
    {
      title: 'SĐT yêu cầu',
      dataIndex: 'customer_phone_number',
      key: 'customer_phone_number',
      width: 130
    },
    {
      title: 'Ngày yêu cầu',
      dataIndex: 'date_view',
      key: 'date_view',
      width: 150,
      render: (_, record) => (
        <span>
          {record?.date_view
            ? dayjs(record.date_view).format('HH:mm:ss DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    { title: 'Nội dung', dataIndex: 'content', key: 'content', width: 120 },
    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 120,
      render: (_, record) => {
        return (
          <Space size="small">
            <>
            {hasPermission('P49.2', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setIsModalOpen(true)
                  setDetail(record)
                    // getDetailImess(record.id)
                  }}
                />
              </Tooltip>
            )}
            {hasPermission('P49.3', permissions) && (
              <Tooltip title="Xóa">
                <Button
                  style={{ width: 32 }}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                  onClick={() =>
                    showConfirm({
                      title: 'Xác nhận xóa',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xóa <b>{record.name}</b>
                        </div>
                      ),
                      onOk: () => handleDelete(record.id)
                    })
                  }
                />
              </Tooltip>
            )}
            </>
          </Space>
        )
      }
    }
  ]

  const handleDelete = async (id) => {
    try {
      const res = await AuctionViewHistoryDelete(id)
      fetchData()
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const [isDisabled, setIsDisabled] = useState(false)
  useEffect(() => {
    const p = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      post_id: filters.post_id || '',
      type: filters.type || '',
      project_id: filters.project_id || '',
      start_date:
        (filters?.date && dayjs(filters?.date[0], 'DD/MM/YYYY').valueOf()) ||
        '',
      end_date:
        (filters?.date && dayjs(filters?.date[1], 'DD/MM/YYYY').valueOf()) || ''
    }
    const cleanedData = Object.fromEntries(
      Object.entries(p).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )
    const params = new URLSearchParams({ ...cleanedData })

    setUrl(
      `${process.env.REACT_APP_API_URL}/api/v1/house-viewing-auction/export?` +
        params
    )
  }, [filters])


const handleSave = async() => {
  setLoading(true)
  try {
    // Validate các trường trong form
    const values = await form.validateFields()
    // Kiểm tra nếu cả hai giá trị đều tồn tại
   
    const res = await AuctionViewHistoryUpdate(
      { status: values.status }, 
      detail?.id
    ); 
    if (res) {
    openNotification(
      'success',
     'Cập nhật thành công'
    )
    fetchData()
    setIsModalOpen(false)
          form.resetFields()
   } else {
      openNotification('error', 'Đã có lỗi xảy ra')
    }
  } catch (err) {
    // Lấy danh sách lỗi từ API
    const errors = get(err, 'response.data.message', [])

    // Xử lý lỗi nếu là mảng
    const errorMessages = Array.isArray(errors)
      ? errors.map((error) => error.message).join('\n')
      : errors // Nếu không phải mảng, lấy trực tiếp

    openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
  } finally {
    setLoading(false)
  }
}
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        ></div>

        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
          setIsDisabled={setIsDisabled}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {hasPermission('P49.1', permissions) && (
            <AuthenticatedLink
              url={url || ''}
              filename={'Danh-sach-lich-su-dau-gia-xem-nha'}
              disabled={isDisabled}
              type={1}
            >
              Export
            </AuthenticatedLink>
          )}
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      <ModalCustom
        title='Chỉnh sửa'
        visible={isModalOpen}
        centered
        width={1200}
        // className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <FormPost form={form} data={detail} handleFinish={() => {}}/>
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default AuctionViewHistory
